import appointment_img from "./appointment_img.png";
import header_img from "./header_img.png";
import group_profiles from "./group_profiles.png";
import profile_pic from "./profile_pic.png";
import contact_image from "./contact_image.png";
import about_image from "./about_image.png";
import logo from "./logo.svg";
import dropdown_icon from "./dropdown_icon.svg";
import menu_icon from "./menu_icon.svg";
import cross_icon from "./cross_icon.png";
import chats_icon from "./chats_icon.svg";
import verified_icon from "./verified_icon.svg";
import arrow_icon from "./arrow_icon.svg";
import info_icon from "./info_icon.svg";
import upload_icon from "./upload_icon.png";
import stripe_logo from "./stripe_logo.png";
import razorpay_logo from "./razorpay_logo.png";
import doc1 from "./doc1.png";
import doc2 from "./doc2.png";
import doc3 from "./doc3.png";
import doc4 from "./doc4.png";
import doc5 from "./doc5.png";
import doc6 from "./doc6.png";
import doc7 from "./doc7.png";
import doc8 from "./doc8.png";
import doc9 from "./doc9.png";
import doc10 from "./doc10.png";
import doc11 from "./doc11.png";
import doc12 from "./doc12.png";
import doc13 from "./doc13.png";
import doc14 from "./doc14.png";
import doc15 from "./doc15.png";
import Dermatologist from "./Dermatologist.svg";
import Gastroenterologist from "./Gastroenterologist.svg";
import General_physician from "./General_physician.svg";
import Gynecologist from "./Gynecologist.svg";
import Neurologist from "./Neurologist.svg";
import Pediatricians from "./Pediatricians.svg";
import divacare_logo from "./divacare_logo.png";
import left_icon from "./left_icon.svg";
import right_icon from "./right_icon.svg";
import calender_icon from "./calender_icon.svg";
import call_icon from "./call_icon.svg";
import card_icon from "./card_icon.svg";
import clock_icon from "./clock_icon.svg";
import mail_icon from "./mail_icon.svg";
import paperroll_icon from "./paperroll_icon.svg";
import profile_icon from "./profile_icon.svg";
import search_icon from "./search_icon.svg";
import whatsapp_icon from "./whatsapp_icon.svg";
import notfound_icon from "./notfound_icon.svg";
import placeholder_clinic_logo from "./placeholder_clinic_logo.png";
import placeholder_avatar_image from "./placeholder_avatar_image.png";
import booking_logo from "./booking_logo.png";
import doctor_whatsapp from "./doctor_whatsapp.png";
import patient_whatsapp from "./patient_whatsapp.png";
import eisha_avatar from "./eisha_avatar.png";
import iphone_frame from "./iphone_frame.png";
import hero_thumbnail from "./hero_thumbnail.png";
import doctor_portal_thumbnail from "./doctor_portal_thumbnail.png";
import doctor_notification_thumbnail from "./doctor_notification_thumbnail.png";
import patient_part_thumbnail from "./patient_part_thumbnail.png";
import website_video_thumbnail from "./website_video_thumbnail.png";
import dr_anita from "./dr_anita.jpeg";
import dr_prathap from "./dr_prathap.jpeg"
import dr_teena from "./dr_teena.jpeg"

export const assets = {
    appointment_img,
    header_img,
    group_profiles,
    logo,
    chats_icon,
    verified_icon,
    info_icon,
    profile_pic,
    arrow_icon,
    contact_image,
    about_image,
    menu_icon,
    cross_icon,
    dropdown_icon,
    upload_icon,
    stripe_logo,
    razorpay_logo,
    divacare_logo,
    left_icon,
    right_icon,
    calender_icon,
    call_icon,
    card_icon,
    clock_icon,
    mail_icon,
    paperroll_icon,
    profile_icon,
    search_icon,
    whatsapp_icon,
    notfound_icon,
    placeholder_clinic_logo,
    placeholder_avatar_image,
    booking_logo,
    doctor_whatsapp,
    patient_whatsapp,
    eisha_avatar,
    iphone_frame,
    hero_thumbnail,
    doctor_portal_thumbnail,
    doctor_notification_thumbnail,
    patient_part_thumbnail,
    website_video_thumbnail,
    dr_anita,
    dr_teena,
    dr_prathap
};

export const specialityData = [
    {
        speciality: "General physician",
        image: General_physician
    },
    {
        speciality: "Gynecologist",
        image: Gynecologist
    },
    {
        speciality: "Dermatologist",
        image: Dermatologist
    },
    {
        speciality: "Pediatricians",
        image: Pediatricians
    },
    {
        speciality: "Neurologist",
        image: Neurologist
    },
    {
        speciality: "Gastroenterologist",
        image: Gastroenterologist
    }
];

export const doctors = [
    {
        _id: "doc1",
        name: "Dr. Richard James",
        image: doc1,
        speciality: "General physician",
        degree: "MBBS",
        experience: "4 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 50,
        address: {
            line1: "17th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc2",
        name: "Dr. Emily Larson",
        image: doc2,
        speciality: "Gynecologist",
        degree: "MBBS",
        experience: "3 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 60,
        address: {
            line1: "27th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc3",
        name: "Dr. Sarah Patel",
        image: doc3,
        speciality: "Dermatologist",
        degree: "MBBS",
        experience: "1 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 30,
        address: {
            line1: "37th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc4",
        name: "Dr. Christopher Lee",
        image: doc4,
        speciality: "Pediatricians",
        degree: "MBBS",
        experience: "2 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 40,
        address: {
            line1: "47th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc5",
        name: "Dr. Jennifer Garcia",
        image: doc5,
        speciality: "Neurologist",
        degree: "MBBS",
        experience: "4 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 50,
        address: {
            line1: "57th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc6",
        name: "Dr. Andrew Williams",
        image: doc6,
        speciality: "Neurologist",
        degree: "MBBS",
        experience: "4 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 50,
        address: {
            line1: "57th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc7",
        name: "Dr. Christopher Davis",
        image: doc7,
        speciality: "General physician",
        degree: "MBBS",
        experience: "4 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 50,
        address: {
            line1: "17th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc8",
        name: "Dr. Timothy White",
        image: doc8,
        speciality: "Gynecologist",
        degree: "MBBS",
        experience: "3 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 60,
        address: {
            line1: "27th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc9",
        name: "Dr. Ava Mitchell",
        image: doc9,
        speciality: "Dermatologist",
        degree: "MBBS",
        experience: "1 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 30,
        address: {
            line1: "37th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc10",
        name: "Dr. Jeffrey King",
        image: doc10,
        speciality: "Pediatricians",
        degree: "MBBS",
        experience: "2 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 40,
        address: {
            line1: "47th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc11",
        name: "Dr. Zoe Kelly",
        image: doc11,
        speciality: "Neurologist",
        degree: "MBBS",
        experience: "4 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 50,
        address: {
            line1: "57th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc12",
        name: "Dr. Patrick Harris",
        image: doc12,
        speciality: "Neurologist",
        degree: "MBBS",
        experience: "4 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 50,
        address: {
            line1: "57th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc13",
        name: "Dr. Chloe Evans",
        image: doc13,
        speciality: "General physician",
        degree: "MBBS",
        experience: "4 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 50,
        address: {
            line1: "17th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc14",
        name: "Dr. Ryan Martinez",
        image: doc14,
        speciality: "Gynecologist",
        degree: "MBBS",
        experience: "3 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 60,
        address: {
            line1: "27th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    },
    {
        _id: "doc15",
        name: "Dr. Amelia Hill",
        image: doc15,
        speciality: "Dermatologist",
        degree: "MBBS",
        experience: "1 Years",
        about: "Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies. Dr. Davis has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies.",
        fees: 30,
        address: {
            line1: "37th Cross, Richmond",
            line2: "Circle, Ring Road, London"
        }
    }
];
